<template>
  <div>
    <div class="custom-autocomplete">
      <label class="data-label">
        {{ label }}
      </label>
      <autocomplete
        ref="autocompleteRef"
        :auto-select="true"
        class="custom-autocomplete__input"
        :class="{ 'is-invalidated': error }"
        :debounce-time="debounceTime"
        :default-value="value"
        :disabled="disabled"
        :get-result-value="getResultValue"
        :placeholder="placeholder"
        :search="search"
        @input="onChangeHandler"
        @submit="$emit('submit', $event)"
      >
        <template #result="{ result, props }">
          <div
            v-if="displayTextName"
            v-bind="props"
            class="custom-autocomplete__result"
          >
            <div class="custom-autocomplete__result__title cursor-pointer">
              {{ result[displayTextName] }}
            </div>
          </div>
          <div
            v-else
            v-bind="props"
            class="custom-autocomplete__custom-result px-3 py-1"
          >
            <div class="d-flex align-items-center cursor-pointer">
              <div class="flex-flex-grow-1">
                <div class="color-black font-14 font-weight-bold">
                  {{ result.fullName | capitalize }}
                </div>
                <div class="color-gray-6 font-14 font-italic">
                  {{ result.userName }} / {{ result.email }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </autocomplete>
      <div
        v-if="inputValue && showClear"
        class="custom-autocomplete__clear cursor-pointer"
        @click="onClearHandler"
      >
        <em class="fas fa-times-circle" />
      </div>
    </div>
    <error
      v-if="error"
      :class="errorClass"
      :message="errorMessage"
      variant="no-border"
    />
  </div>
</template>

<script>
import Autocomplete from '@trevoreyre/autocomplete-vue';
import Error from 'custom-error';
export default {
  name: 'CustomAutoComplete',
  components: {
    Autocomplete,
    Error,
  },
  props: {
    disabled: {
      type: Boolean,
      default: () => false,
    },
    search: {
      type: Function,
      required: true,
    },
    getResultValue: {
      type: Function,
      default: () => {},
    },
    debounceTime: {
      type: Number,
      default: () => 0,
    },
    placeholder: {
      type: String,
      default: () => '',
    },
    displayTextName: {
      type: String,
      default: () => '',
    },
    label: {
      type: String,
      default: () => '',
    },
    showClear: {
      type: Boolean,
      default: () => false,
    },
    error: {
      type: String,
      default: '',
    },
    errorClass: {
      type: String,
      default: '',
    },
    customErrorMsg: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    inputValue: null,
  }),
  watch: {
    error: function(newValue) {
      if (this.customErrorMsg == null) this.errorMessage = newValue;
    },
    customErrorMsg: function(newValue) {
      this.errorMessage = newValue;
    },
  },
  methods: {
    onChangeHandler(event) {
      this.inputValue = event.target.value;
      this.$emit('changed', this.inputValue);
    },
    onClearHandler() {
      this.$refs.autocompleteRef.value = null;
      this.inputValue = null;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';

:deep(ul::-webkit-scrollbar) {
  width: 0.8rem;
  background-color: map-get($colors, 'secondary-9');
}
:deep(ul::-webkit-scrollbar-thumb) {
  border-radius: 10px;
  background-color: map-get($colors, 'secondary-8');
}
.is-invalidated {
  border-radius: 7px;
  border: 1px solid #ff0018 !important;
}
.custom-autocomplete {
  &__input {
    ::v-deep {
      .autocomplete {
        input {
          height: 36px;
          width: 100%;
          background: map-get($colors, 'white');
          border: 1px solid #e2e2e2;
          border-radius: 5px;
          padding-left: 15px;
          outline: none;
          &::placeholder {
            color: map-get($colors, 'secondary-6');
            font-size: 1rem;
          }
        }
        ul {
          padding: 0rem;
          overflow-y: scroll;
          max-height: 14rem;
          background-color: map-get($colors, 'white');
          list-style-position: inside;
          box-shadow: 0px 3px 6px #00000029;
        }
      }
    }
  }
  &__result {
    border: 1px solid #9f9f9f;
    padding: 10px 0px 10px 10px;
    &__title {
      color: #11291b;
    }
  }
  &__custom-result {
    border: 1px solid map-get($colors, 'gray-9');
  }
  &__clear {
    position: absolute;
    top: 37px;
    right: 28px;
    color: map-get($colors, 'gray-10');
  }
}
</style>
